/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Tag, breakpoints } from '@coursera/cds-core';

const styles = {
  topRecColor: css`
    background: linear-gradient(309.51deg, #bbdefe 6.59%, var(--cds-color-green-100) 100%);
    background-blend-mode: multiply;
    border: none;
    margin-left: -16px;
    color: var(--cds-color-neutral-primary) !important;
    position: relative;
    margin-bottom: var(--cds-spacing-200);
    ${breakpoints.down('sm')} {
      margin-left: 0;
    }
  `,
};

type Props = {
  label: string;
};
const GradientBadge = ({ label }: Props) => {
  return (
    <div>
      <Tag
        css={styles.topRecColor}
        variant="status"
        priority="secondary"
        color="highlight1"
        data-testid="top-recommendation-badge"
      >
        {label}
      </Tag>
    </div>
  );
};

export default GradientBadge;
